import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import '../../styles/common/modal.css';

const OverwriteConfirmModal = ({ isOpen, onConfirm, onCancel, fileType }) => {
  // 모달이 열리면 페이지 스크롤 방지
  useEffect(() => {
    if (isOpen) {
      // 모달이 열리면 배경 스크롤 방지
      document.body.style.overflow = 'hidden';
      
      // 컴포넌트 언마운트 시 원래대로 복원
      return () => {
        document.body.style.overflow = 'auto';
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  // 모달 외부 클릭 방지를 위한 이벤트 핸들러
  const handleOverlayClick = (e) => {
    // 모달 내부 클릭은 처리하지 않음
    if (e.target === e.currentTarget) {
      // 모달 외부 클릭 시 아무 동작도 하지 않음
      e.stopPropagation();
    }
  };

  return (
    <div 
      className="modal-overlay" 
      onClick={handleOverlayClick}
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}
    >
      <div 
        className="modal-content"
        style={{
          backgroundColor: '#fff',
          padding: '30px',
          borderRadius: '8px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}
      >
        <h2>File Replacement Confirmation</h2>
        <p>You can only upload one file. The new file will overwrite the existing {fileType} file when you save or submit the form.</p>
        <div className="modal-buttons">
          <button 
            className="modal-button cancel" 
            onClick={onCancel}
            style={{
              backgroundColor: '#f3f4f6',
              color: '#1f2937',
              border: 'none',
              padding: '10px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              marginRight: '10px'
            }}
          >
            Cancel
          </button>
          <button 
            className="modal-button save" 
            onClick={onConfirm}
            style={{
              backgroundColor: '#2563eb',
              color: 'white',
              border: 'none',
              padding: '10px 16px',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  );
};

OverwriteConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  fileType: PropTypes.string.isRequired
};

export default OverwriteConfirmModal; 